import { render } from "./TipWidget.vue?vue&type=template&id=f6540092&scoped=true"
import script from "./TipWidget.vue?vue&type=script&lang=js"
export * from "./TipWidget.vue?vue&type=script&lang=js"

import "./TipWidget.vue?vue&type=style&index=0&id=f6540092&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6540092"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QIcon,QTooltip});
